import {Autocomplete, Box, Card, FormLabel, Grid} from "@mui/material";
import React, {FC} from "react";
import * as z from "zod";
import {Controller, useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import TextField from "@mui/material/TextField";
import {DialogFooter} from "@/widget/DialogModal/DialogModal";

import {emptyValue} from "@/helper/method";
import {RoleUserVO} from "@/service/user.s";
import FormControl from "@mui/material/FormControl";

export interface TransferFormFormProps {
    ids: number[];
    users: RoleUserVO[]
    content: string
    submitCallback: (values: WriteTransferForm) => void;
}

const validationSchema = z.object({
    userId: z.number({message: "请选择转移人"}),
    username: z.ostring(),
    tempUser: z.object({username: z.string().default(''), id: z.number()}).optional(),
});

export type WriteTransferForm = z.infer<typeof validationSchema>
const defaultValues = emptyValue(validationSchema)

export const TransferForm: FC<TransferFormFormProps> = ({users, submitCallback, content}) => {
    const {
        handleSubmit,
        control,
        setValue,
        reset,
        formState: {errors},
    } = useForm<WriteTransferForm>({
        resolver: zodResolver(validationSchema),
        defaultValues: defaultValues,
    });

    const onSubmit = async (values: WriteTransferForm) => {
        submitCallback && submitCallback(values);
    }

    return <Box component={'form'} display={'flex'} flexDirection={'column'} rowGap={2} noValidate onSubmit={handleSubmit(onSubmit)}>
        <Grid spacing={2} container width={'inherit'}>
            <Grid size={12}>
                <Card sx={{p: 1.3}}>{content}</Card>
            </Grid>
            <Grid size={12}>
                <FormControl fullWidth={true} required={true}>
                    <Controller control={control} render={({field: {onChange, value}}) => {
                        return <Autocomplete
                            options={users || []}
                            value={value}
                            onChange={(_, value: RoleUserVO | null) => {
                                setValue("userId", value!.id)
                                setValue("username", value?.username)
                                onChange(value)
                            }}
                            isOptionEqualToValue={(option, value) => option.id == value.id}
                            getOptionKey={option => option.username}
                            getOptionLabel={option => option.username}
                            fullWidth
                            renderInput={(params) => (
                                <TextField error={!!errors?.userId}
                                           helperText={errors?.userId?.message}
                                           variant="outlined"
                                           placeholder={"选择转移人"} {...params} />
                            )}
                        />
                    }} name={"tempUser"}/>
                </FormControl>
            </Grid>
        </Grid>
        <DialogFooter onReset={() => reset(defaultValues)}/>
    </Box>
}